















import { Component, Vue } from 'vue-property-decorator';
import NavigationComponent from './Nav/Navigation.vue';

@Component({ components: { NavigationComponent } })
export default class HeaderComponent extends Vue {}
